import { render } from "./MostSalesLocation.vue?vue&type=template&id=b15d8f6a&ts=true"
import script from "./MostSalesLocation.vue?vue&type=script&lang=ts"
export * from "./MostSalesLocation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__